import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cancelSubscription } from "../lib/callables";

export function AccountCancelPage() {
  const nav = useNavigate();
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function confirm() {
    setBusy(true);
    setError(null);
    try {
      await cancelSubscription({});
      nav("/account", { replace: true });
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 560, margin: "0 auto" }}>
      <div className="acx__card">
        <header className="acx__card-header">
          <span className="acx__card-eyebrow">{t("cancel.eyebrow")}</span>
          <h1 className="acx__card-title">{t("cancel.title")}</h1>
        </header>
        <div className="acx__stack acx__stack--lg">
          <p style={{ color: "var(--acx-text-muted)", lineHeight: "var(--acx-lh-snug)" }}>{t("cancel.body")}</p>
          <div className="acx__row">
            <button onClick={confirm} disabled={busy} className="acx__btn acx__btn--danger">
              {busy ? t("cancel.cancellingCta") : t("cancel.confirmCta")}
            </button>
            <button onClick={() => nav("/account")} disabled={busy} className="acx__btn acx__btn--ghost">
              {t("cancel.abortCta")}
            </button>
          </div>
          {error && <div className="acx__alert acx__alert--danger">{error}</div>}
        </div>
      </div>
    </div>
  );
}
